module.exports = __webpack_public_path__ + "product-pure-powder-capsule-main-thumb-02.jpg?c0c6a6ecb9af513d691b197a8793da14";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-main-thumb-02.jpg
// module id = 81
// module chunks = 0